import { Container, Heading, Reveal, Section } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { FaqItem } from './FaqItem.tsx';

/**
 * `#faq` — `template.html:1027`.
 *
 * KHÔNG dùng `SectionHead`: section này không có eyebrow và không có lead (thiết kế chỉ có một h2
 * canh giữa), mà `eyebrow` là prop BẮT BUỘC của `SectionHead`.
 *
 * Bậc chữ h2 ở đây là hàng 34px được gộp có chủ đích vào `--text-h2` (40). Nhãn gộp đó đã được ĐO
 * cho `#faq` chứ không suy — xem ledger; tiêu chí là "gộp chỉ hợp lệ khi KHÔNG đổi số dòng ở bề
 * rộng thật của khối".
 *
 * `tone="muted"` — nền mờ, kẻ CẢ trên lẫn dưới. Từ 2026-09-28 LỆCH thiết kế `:1027` (vốn chỉ kẻ
 * trên, tone `muted-top`) có chủ ý: lý do của `muted-top` là `#faq` nằm sát `#cta` gradient, mà giờ
 * `#download` nền trắng chen vào giữa. Nền mờ gặp nền trắng mà không có nét kẻ là đúng thứ mọi
 * section nền mờ khác của trang đều tránh. `muted-top` vẫn ở lại `Section` — đặt `#download` đi chỗ
 * khác là quay về nó.
 *
 * Nợ D-1 của lô D là chỗ này: lúc đó `Section` chỉ có `muted` (kẻ trên/dưới) và `packages/ui` là
 * vùng đóng băng, nên `#faq` thừa một nét `ink-100` 1px ở đáy, nằm ngay trên `#cta` nền gradient.
 * User chốt chịu nợ đó 2026-08-20, rồi **ĐẢO quyết định 2026-08-21** và cho trả — xem plan §0.3.
 *
 * ⚠️ Đừng "sửa" bằng cách thêm class bỏ viền dưới: hai utility cùng thuộc tính sẽ cùng tồn tại và
 * thắng thua do thứ tự Tailwind xếp trong CSS, không do thứ tự ta viết. Đường đúng là một khoá
 * khác của bảng `TONE`, và đó là đường đã đi.
 */
export function FaqSection() {
  const copy = useCopy();

  return (
    <Section id="faq" tone="muted" labelledBy="faq-head" cv className="nx-cv-faq">
      <Container width="narrow">
        <Reveal>
          <Heading level={2} id="faq-head" className="mb-8 text-center">
            {copy.faq.heading}
          </Heading>
        </Reveal>

        <div className="flex flex-col gap-2.5">
          {copy.faq.items.map((item) => (
            <Reveal key={item.question}>
              <FaqItem {...item} />
            </Reveal>
          ))}
        </div>
      </Container>
    </Section>
  );
}
